import { useFormik } from "formik"
import * as Yup from "yup"

import { useUI } from "providers/UIProvider"

import { useEmployeesContext } from "providers/EmployeesProvider"
import { useAppContext } from "providers/AppProvider/AppProvider"
import { IAddEmployeeBodyParams } from "types/employee"

const phoneRegExp = /^5[0-9]{8}$/

const INITIAL_VALUES = {
  fullName: "",
  personalCode: "",
  phoneNumber: "",
  roleId: "",
  salaryPercent: "",
}

const ADD_EMPLOYEE_SCHEMA = (t: any) =>
  Yup.object({
    fullName: Yup.string().required(
      t("employees.form.validations.fullName_required"),
    ),
    personalCode: Yup.string().required(
      t("employees.form.validations.personalCode_required"),
    ),
    phoneNumber: Yup.string()
      .required(t("employees.form.validations.phoneNumber_required"))
      .matches(phoneRegExp, t("employees.form.validations.phone_invalid")),
    roleId: Yup.string().required(
      t("employees.form.validations.roleId_required"),
    ),
  })

const useEmployees = (employeeData: any) => {
  const { selectedBranches } = useAppContext()
  const { addEmployee, updateEmployee } = useEmployeesContext()
  const { T } = useUI()

  const editMode = employeeData ? true : false

  const onSubmit = () => {
    if (editMode) {
      const updatedEmployeeData = {
        ...employeeData,
        ...values,
        salaryPercent: Number(values.salaryPercent),
        personalCode: values.personalCode.toString(),
        phoneNumber: values.phoneNumber.toString(),
      }
      console.log(updatedEmployeeData)
      updateEmployee(updatedEmployeeData)
    } else {
      const addedEmployeeData: IAddEmployeeBodyParams = {
        ...values,
        salaryPercent: Number(values.salaryPercent),
        personalCode: values.personalCode.toString(),
        phoneNumber: values.phoneNumber.toString(),
      }

      if (selectedBranches.length === 1) {
        addedEmployeeData.carWashId = selectedBranches[0]
      }

      addEmployee(addedEmployeeData)
    }
  }

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    setValues,
    setErrors,
    setFieldTouched,
    setFieldValue,
    handleSubmit,
    resetForm,
  } = useFormik({
    initialValues: INITIAL_VALUES,
    validationSchema: () => ADD_EMPLOYEE_SCHEMA(T),
    onSubmit,
  })

  return {
    form: {
      values,
      errors,
      touched,
      handleSubmit,
      handleChange,
      handleBlur,
      setValues,
      setErrors,
      resetForm,
      setFieldTouched,
      setFieldValue,
    },
  }
}

export default useEmployees
